import { AllCardsType } from '../../../data/all-cards'
import { NombreTarotista } from '../../../data/personality'
import { DataTypePregunta } from '../../../interfaces/utils'
import { formatCardLabel } from '../../../utils/card-label'

const cardLabel = (card: AllCardsType) => formatCardLabel(card)

export const interpret = (
    cards: AllCardsType[],
    data: DataTypePregunta,
    user: string,
    personality: NombreTarotista,
    type: string
) => {
    const consult = `Antes de interpretar, identificá qué tipo de situación laboral trae la persona (búsqueda de empleo, conflicto en el trabajo, negocio propio, post-entrevista, etc.). Adaptá el lenguaje de cada posición a ese contexto sin forzar un significado fijo.

Quiero que interpretes una **Lectura Laboral** de 10 cartas para ${data.consultante.name}${
        data.consultante.zodiac ? ` de signo ${data.consultante.zodiac}` : ''
    }${
        data.consulta.length > 0
            ? `, que realiza la siguiente consulta: ${data.consulta}`
            : ''
    }.

Las primeras 8 cartas son las posiciones principales:
1. **Situación actual** (${cardLabel(cards[0])}): dónde está realmente parado hoy.
2. **El nudo** (${cardLabel(cards[1])}): el verdadero obstáculo (no siempre es el que cree).
3. **Lo que no se ve** (${cardLabel(cards[2])}): influencias ocultas, energías de otras personas o bloqueos internos.
4. **Tu poder** (${cardLabel(cards[3])}): qué sí controla / fortalezas que está subutilizando.
5. **El campo externo** (${cardLabel(cards[4])}): oportunidades, tendencias del mercado, personas clave.
6. **Consejo concreto** (${cardLabel(cards[5])}): la acción o el cambio de mirada más importante ahora.
7. **Posible desarrollo** (${cardLabel(cards[6])}): cómo puede evolucionar si sigue como está (tendencia, no sí/no).
8. **El paso siguiente** (${cardLabel(cards[7])}): la acción más alineada para los próximos 15-30 días.

Las cartas 9 y 10 son de **clarificación** (${cardLabel(cards[8])} y ${cardLabel(
        cards[9]
    )}): usalas solo si necesitás ampliar o precisar algún punto de la lectura; no hace falta forzarlas si el relato ya quedó claro.

Hacé un relato fluido nombrando las cartas dentro de la interpretación (sin enumeración fría carta por carta). Sé claro, concreto y práctico. Dirígete directamente al consultante en segunda persona. Al final, incluí un párrafo de **respuesta directa** a su inquietud laboral y un **consejo final**.`

    return {
        consult,
        user,
        personality,
        clientName: data.consultante.name,
        clientPhone: data.consultante.phone || '',
        clientAnswer: data.consulta,
        cards,
        type,
    }
}
